module.exports = __webpack_public_path__ + "img/Dinner.4ed37c9e.jpg";